// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4afdd21","239":"c2bb7509","453":"f7c38ebf","732":"6a03143d"}[chunkId] + ".chunk.js";
};